import app from 'flarum/app';
import {Extend} from '@flarum/core/forum';
import addLinks from './addLinks';
import addRoutes from './addRoutes';
import addFormOnDiscussionPost from './addFormOnDiscussionPost';
import File from './models/File';
import Form from './models/Form';
import Submission from './models/Submission';
import FormIndexPage from './pages/FormIndexPage';
import FormShowPage from './pages/FormShowPage';
import FormEditPage from './pages/FormEditPage';
import SubmissionIndexPage from './pages/SubmissionIndexPage';
import SubmissionPage from './pages/SubmissionPage';
import DebugPage from './pages/DebugPage';
import ProfilePage from './pages/ProfilePage';
import patchStore from './patchStore';
import addSignUpFields from './addSignUpFields';

export * from './components';
export * from './fields';
export * from './pages';

export const extend = [
    new Extend.Model('formulaire-files', File),
    new Extend.Model('formulaire-forms', Form),
    new Extend.Model('formulaire-submissions', Submission),
    new Extend.Model('forums')
        .attribute('formulaireCanManage')
        .hasMany('formulaireSignUpForms')
        .hasMany('formulaireComposerForms'),
    new Extend.Model('discussions')
        .hasMany('formulaireForms')
        .hasMany('formulaireSubmissions'),
    new Extend.Model('users')
        .hasMany('formulaireForms')
        .hasMany('formulaireSubmissions'),

    new Extend.Routes()
        .add('formulaireFormIndex', '/formulaire', FormIndexPage.component())
        .add('formulaireFormIndexDiscussion', '/formulaire/discussion', FormIndexPage.component())
        .add('formulaireFormIndexUser', '/formulaire/user', FormIndexPage.component())
        .add('formulaireFormShow', '/forms/:id', FormShowPage.component())
        .add('formulaireFormEdit', '/formulaire/:id', FormEditPage.component())
        .add('formulaireSubmissionIndex', '/formulaire/:id/submissions', SubmissionIndexPage.component())
        .add('formulaireSubmission', '/submissions/:id', SubmissionPage.component())
        .add('formulaireDebug', '/formulaire-debug', DebugPage.component())
        .add('formulaireProfile', '/u/:username/forms/:form', ProfilePage.component()),
];

app.initializers.add('kilowhat-formulaire', () => {
    addLinks();
    addFormOnDiscussionPost();
    addRoutes();
    addSignUpFields();
    patchStore();
});
